/**
 * Funções de agregação de uma grandeza, na ordem em que as telas oferecem.
 * Espelha FUNCOES_AGREGACAO_VALIDAS em api/models/SubsidioMotorCatalogo.js.
 */
const FUNCOES = [
  { value: "SOMA", i18n: "sum" },
  { value: "MEDIA", i18n: "avg" },
  { value: "CONTAGEM", i18n: "count" },
  { value: "CONTAGEM_DISTINTA", i18n: "countDistinct" },
  { value: "MEDIA_DIARIA_DISTINTA", i18n: "dailyAvgDistinct" },
  { value: "MIN", i18n: "min" },
  { value: "MAX", i18n: "max" },
  { value: "ULTIMO", i18n: "last" },
];

export function funcaoAgregacaoOptions(t) {
  return FUNCOES.map((f) => ({ value: f.value, text: t(`subsidyMotorCatalog.aggregations.${f.i18n}`) }));
}
